const NotFound: React.FC = () => {
  return (
    <div className="flex flex-col min-h-0">
      <div className="pb-8 flex-grow flex items-center justify-center bg-gray-100 lg:py-8">
        <div className="bg-white p-5 shadow-md w-full min-h-48 flex flex-col justify-center lg:max-w-lg lg:p-8 lg:rounded-lg">
          <h2 className="text-3xl font-semibold text-center text-orange-600 mb-6">Page not found</h2>
          <p className="text-lg text-center mb-4">Unfortunately, the page you are looking for does not exist.</p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;